import { useMemo, useState } from 'react'
import * as ClientHttp from '../../../../../services/api/https/registration/client.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SWITCH_ASSOC: 'Alterando associação',
  INITIAL_CHECK: 'Adquirindo associacões',
}

const INITIAL_STATE = {
  associations: [],
  association: {
    client_id: 0,
    id: 0,
    actived: '',
    tp_id: 0,
  },
  customer: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useModalAssocOpLog() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      switchCustomerAssociationWithTP(association) {
        ClientHttp.clientTpAssociatonHandler(
          association.client_id,
          association.tp_id,
          association.id ? !association.actived : association.actived,
        )
          .then(associationsRes =>
            setState(prevState => ({
              ...prevState,
              associations: associationsRes,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      getTpsCustomerAssociation(clientID) {
        if (clientID)
          ClientHttp.getClientTpsAssociaton(clientID)
            .then(associationsRes =>
              setState(prevState => ({
                ...prevState,
                associations: associationsRes,
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(err),
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
      },

      resetState() {
        setState({ ...INITIAL_STATE })
      },

      // Events
      onInit(customer) {
        setState(prevState => ({
          ...prevState,
          customer: customer,
          loadingMessage: LOAD_MESSAGE.INITIAL_CHECK,
        }))
      },

      onCheckBoxClicked(association) {
        setState(prevState => ({
          ...prevState,
          association: association,
          loadingMessage: LOAD_MESSAGE.SWITCH_ASSOC,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
